<p-toast position="bottom-right"></p-toast>
<div [ngClass]="'cc-rich-field'">
  <p-table #table styleClass="p-datatable-sm p-datatable-striped"
           [value]="formRecords" [scrollable]="true">
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr [pSelectableRow]="record" [pContextMenuRow]="record"
      [pSelectableRowIndex]="rowIndex">
        <td *ngFor="let columnDef of formRichFieldConfig.tableConfigs; let i = index"
            [style.min-width]="columnDef.width ? columnDef.width+'px' : null"
            [style.flex-basis]="columnDef.width ? columnDef.width+'px' : null"
            (click)="copiedToClipboard()"
            [cdkCopyToClipboard]="columnDef.mapId?fieldValueMap['mapId-' + i + '_' + rowIndex]:record[columnDef.field]">
          <span
            *ngIf="columnDef.field && !columnDef.command && !columnDef.format && !columnDef.mapId"
            [title]="record[columnDef.field]">
            {{record[columnDef.field]}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='DATETIME'||columnDef.type==='DATE')"
                [title]="record[columnDef.field]  | date:columnDef.format">
            {{record[columnDef.field]  | date:columnDef.format}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='NUMERIC')"
                [title]="record[columnDef.field]  | number:columnDef.format?columnDef.format:'1.0-7'">
            {{record[columnDef.field]  | number:columnDef.format?columnDef.format:'1.0-7'}}
          </span>
          <span *ngIf="columnDef.field && columnDef.mapId"
                [innerHTML]="fieldValueMap['mapId-' + i + '_' + rowIndex]"
                [title]="fieldValueMap['mapId-' + i + '_' + rowIndex]">
          </span>
          <span *ngIf="columnDef.label"
                [innerHTML]="columnDef.label | translate">
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
